// extracted by mini-css-extract-plugin
module.exports = {"Title":"Layout_Title__2Rclo","div":"Layout_div__4Hlrl"};